import React from 'react'
import { IoChevronDown } from 'react-icons/io5'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/UI/BaseDropdown/dropdown-base'
import { FilterCriteria } from '../FilterStore'

interface FilterCriteriaSelectorProps {
  value: FilterCriteria
  onChange: (value: FilterCriteria) => void
}

const CRITERIA_OPTIONS: { value: FilterCriteria; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'one', label: 'One' },
  { value: 'neither', label: 'None' },
]

export function FilterCriteriaSelector({
  value,
  onChange,
}: FilterCriteriaSelectorProps) {
  const selectedLabel =
    CRITERIA_OPTIONS.find((opt) => opt.value === value)?.label || 'All'

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-baseline !border-0 !border-b !border-line-brand bg-transparent cursor-pointer mx-2 px-0 gap-1 relative top-[1px]"
        >
          <span className="text-sm font-medium text-brand">
            {selectedLabel}
          </span>
          <IoChevronDown className="w-4 h-4 text-brand relative top-[3px]" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="min-w-[92px] p-2 bg-white border border-pistachio-100 shadow-[0px_4px_8px_3px_rgba(6,81,47,0.1)] rounded-[6px]"
      >
        {CRITERIA_OPTIONS.filter((option) => option.value !== value).map(
          (option) => (
            <DropdownMenuItem
              key={option.value}
              onClick={() => onChange(option.value)}
              className="px-2 py-1 text-sm text-fg cursor-pointer hover:bg-sage-lt rounded-sm"
            >
              {option.label}
            </DropdownMenuItem>
          )
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
